class DeleteFile {
  constructor(store, isHierarchy = false) {
    this.global = !store;
    this.STORE_ID = store ? store : '';
    this.fileNames = {};
    this.confirmationModals = {};
    this.isHierarchy = isHierarchy;
  }

  get dom() {
    return {
      DELETE_BUTTON: '.store.delete-file-button.button',
    };
  }

  registerConfirmationModal(rel, modal) {
    this.confirmationModals[rel] = modal;
  }

  setSelectedFile(target) {
    this.fileNames[this._getRel(target)] = target.value;
  }

  updateDeleteButton(target) {
    let el = $(target).find(`option[value="${target.value}"]`);
    const canDeleteGlobal = $(el).data('delete-global');
    const canDeleteNode = $(el).data('delete-node');
    const correctScope = this.global
      ? $(el).data('global') && canDeleteGlobal
      : !$(el).data('global') && canDeleteNode;

    if (correctScope) {
      $(this.dom.DELETE_BUTTON).show();
    } else {
      $(this.dom.DELETE_BUTTON).hide();
    }
  }

  _showConfirmationModal(fileName, rel, owner, msg, confirmationCallback) {
    var warnModal, route;

    if (rel === 'store' || rel === 'hierarchy') {
      route = `hierarchy_template_impact?filename=${fileName}&hierarchy_field_id=${owner}`;

      if (rel === 'store') {
        route = this.global
          ? `global_template_impact?filename=${fileName}`
          : `store_template_impact?filename=${fileName}&store_id=${owner}`;
      }

      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: `/${currentCustomer}/${route}`,
        jst_template: 'stores/templates/impacted',
        modalWidth: 640,
        method: 'GET',
      });

      warnModal.impact();
      warnModal.answer((proceed) => {
        if (proceed) {
          this._delete(owner, rel, fileName);
        }
        warnModal.destroy();
      });
    } else {
      this.confirmationModal = new IO.Views.ConfirmationModal({
        el: '#confirmation-modal',
        closable: false,
      });
      this.confirmationModal.show(msg, confirmationCallback);
    }
  }

  _getConfirmationMsg(rel, fileName) {
    if (typeof this.confirmationModals[rel] !== 'undefined') {
      return this.confirmationModals[rel](fileName);
    }
    return `Are you sure you want to delete file <b>${fileName}</b>?`;
  }

  _getRel(target) {
    return target.getAttribute('rel')
      ? target.getAttribute('rel')
      : target.parentNode.getAttribute('rel');
  }

  _delete(owner, rel, fileName) {
    $.ajax({
      headers: {
        'X-Transaction': 'POST Example',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      },
      url: '/' + currentCustomer + '/delete_store_files',
      type: 'POST',
      data: { xml_file: $.trim(fileName), owner_id: owner, rel: rel }, // eslint-disable-line camelcase
    }).done(() => Turbolinks.visit(location.href));
  }

  _getFileInfo(e) {
    let rel = this._getRel(e.target);

    return { rel: rel, fileName: this.fileNames[rel], owner: this.STORE_ID };
  }

  delete(information) {
    let { rel, fileName, owner } = this.isHierarchy
        ? { ...information, rel: 'hierarchy' }
        : this._getFileInfo(information),
      confirmationMsg = this._getConfirmationMsg(rel, fileName);

    this._showConfirmationModal(
      fileName,
      rel,
      owner,
      confirmationMsg,
      (proceed) => {
        if (proceed) {
          this._delete(owner, rel, fileName);
        }
      },
    );
  }

  removeModalListener() {
    if (this.confirmationModal) {
      this.confirmationModal.removeListener();
    }
  }
}

module.exports = DeleteFile;
